import React from "react";
import CookieConsent from "../components/cookieConsent";
import Layout from "../components/layout";
import Seo from "../components/seo";
import HomepageContainer from "../components/homepageContainer";

export default function Home() {
  return (
    <Layout>
      <CookieConsent/>
      <Seo/>
      <HomepageContainer />
    </Layout>
  );
}
